import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { environment } from "./utility/environment";
import { getSupportedLanguage } from "./utility/languageUtils";

// console.log('i18n config...', navigator.language);

const selectedLanguage = getSupportedLanguage();

i18n
.use(Backend)
.use(initReactI18next)
.init({
    backend: {
        // 本地端用這個
        // loadPath: "/locales/{{lng}}/{{ns}}.json",
        loadPath: `${environment.localePath}/{{lng}}/{{ns}}.json`,
        // loadPath: "/react-i18n-example/locales/{{lng}}/{{ns}}.json",
     },
    fallbackLng: 'en-US', // 如果當前切換的語言沒有對應的翻譯則使用這個語言
    lng: selectedLanguage, // 使用語言對應邏輯
    interpolation: {
        escapeValue: false,  //如果語系檔中有巢狀的結構，則 escapeValue 要設為 false，這樣就可以透過物件的方式來取得巢狀內的翻譯
    },
});
// i18n.changeLanguage(navigator.language)
export default i18n;